import BackgroundGradient from 'react-scale/components/tailwind/BackgroundGradient';
import Header from 'react-scale/components/ui/header';
import TryBanner from 'react-scale/components/sections/cta/simple-centered';
import Footer from 'react-scale/components/ui/footer';
import { navigationLinks } from 'react-scale/components/pages/careers/Content';
import { Navigation } from 'react-scale/components';
import dynamic from 'next/dynamic';

const DynamicJobDescription = dynamic(
  () => import('react-scale/components/pages/careers/Jobs/jobDescription'),
  {
    ssr: false
  }
);

const JobListingPage = ({ position }) => (
  <div>
    <BackgroundGradient />
    <div className="relative">
      <Header
        title={`${position.title} - Scale`}
        description="Join us as we accelerate the development of AI applications"
        canonical={`https://scale.com/careers/${position.id}`}
        theme="light"
        ogImg="https://scale.com/static/img/website/careers/fb-card.jpg"
        twImg="https://scale.com/static/img/website/careers/tw-card.jpg"
      />
      <Navigation
        sticky={false}
        title={navigationLinks.title}
        links={navigationLinks.links}
        theme="light"
      />
      <div className="container">
        <DynamicJobDescription position={position} />
      </div>
      <TryBanner theme="light" border />
      <Footer theme="light" border />
    </div>
  </div>
);

export async function getServerSideProps(ctx) {
  const positionUrl = `https://boards-api.greenhouse.io/v1/boards/scaleai/jobs/${ctx.params.id}`;

  const positionResponse = await fetch(positionUrl);
  const position = await positionResponse.json();

  return {
    props: {
      position
    }
  };
}

export default JobListingPage;
